<template>
	<div
		class="app-wrapper margin-top-xs-4 margin-bottom-xs-4"
		id="pem-course-app"
	>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 col-md-12 col-lg-5 col-xl-4">
					<LeftSidebar />
				</div>
				<div class="col-12 col-md-12 col-lg-7 col-xl-8">
					<ContentArea />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import LeftSidebar from "./LeftSidebar.vue";
import ContentArea from "./ContentArea.vue";

export default {
	name: "App",
	props: [],
	components: { LeftSidebar, ContentArea },
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	methods: {
		/* If there are query parameters set, handle them appropriately */
		handleQueryParameters() {
			//http://localhost:4000/malmedvetet-naringsliv/#?show=signup&group_key=5db9539492a6f
			var params = new URLSearchParams(window.location.href);
			var groupKey = params.get("group_key");
			var passwordResetKey = params.get("password_reset_key");
			if (groupKey) {
				this.$store.state.sidebar = "signup";
			}
			if (passwordResetKey) {
				this.$store.state.passwordResetKey = passwordResetKey;
				this.$store.state.sidebar = "reset-password";
			}
		}
	},
	created() {},
	mounted() {
		this.$store.dispatch("getCourseData");
		if (window.pem.user != undefined) {
			this.$store.dispatch("doLoginExistingUser", {
				nonce: window.pem.user.nonce
			});
		}
		this.handleQueryParameters();
	}
};
</script>